<div class="admin-invitations-container">
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-4">
      <mat-form-field class="custom-form !min-w-[220px]">
        <mat-label>{{ 'pages.admin.userGroup.tabs.invitations.role' | translate }}</mat-label>
        <mat-select
          data-testid="admin-invitations-role-select"
          (selectionChange)="onRoleChange($event.value)"
          [value]="selectedRole()"
        >
          @for (option of roleOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div
      class="flex items-center justify-center"
      matTooltipPosition="above"
      [matTooltip]="'pages.admin.userGroup.tabs.invitations.inviteDisabledMessage' | translate"
      [matTooltipDisabled]="canInvite()"
    >
      <button
        *hasPermission="[EPermissions.campaignUserInvitationCreate, EPermissions.supportUserInvitationCreate]"
        mat-flat-button
        [disabled]="!canInvite()"
        (click)="onInviteClick()"
      >
        {{ 'pages.admin.userGroup.tabs.invitations.invite' | translate }}
      </button>
    </div>
  </div>

  @if (selectedRole()) {
    <app-datatable
      data-testid="admin-invitations-datatable"
      [rowData]="dataSource().data"
      [columns]="datatableColumns"
      [configurationInput]="datatableConfig"
      [customColumnDef]="[
        { name: 'status', isSortable: false, template: statusColumn },
        { name: 'userGroupId', isSortable: true, template: userGroupColumn },
        { name: 'email', isSortable: true, template: emailColumn },
        { name: 'createdAt', isSortable: true, template: createdAtColumn },
      ]"
      [total]="store.dataTotal$()"
      [loaderConfig]="skeletonLoaderConfig"
      [isInitialDataLoaded]="loadedTableData()"
      [loadingData]="store.dataLoading$()"
      (dataRefreshRequest)="datatableParams$.next($event)"
      (rowClick)="onRowClick($event)"
    />

    <ng-template #statusColumn let-row="row">
      <div class="flex items-center">
        @if (row.createdUserId) {
          <span class="rounded-full bg-shikenso-success-base w-4 h-4"></span>
          <span class="ml-2">{{ 'shared.statuses.joined' | translate }}</span>
        } @else if (row.isExpired) {
          <span class="rounded-full bg-shikenso-error-base w-4 h-4"></span>
          <span class="ml-2">{{ 'shared.statuses.expired' | translate }}</span>
        } @else {
          <span class="rounded-full bg-shikenso-warning-base w-4 h-4"></span>
          <span class="ml-2">{{ 'shared.statuses.pending' | translate }}</span>
        }
      </div>
    </ng-template>

    <ng-template #userGroupColumn let-row="row">
      <div class="flex items-center">
        <span>{{ row.userGroupName ?? row.userGroupId ?? '-' }}</span>
      </div>
    </ng-template>

    <ng-template #emailColumn let-row="row">
      <div class="flex items-center">
        <span>{{ row.email }}</span>
      </div>
    </ng-template>

    <ng-template #createdAtColumn let-row="row">
      <div class="flex items-center">
        <span>{{ row.createdAt ? (row.createdAt | date: 'dd.MM.yyyy HH:mm') : '-' }}</span>
      </div>
    </ng-template>
  } @else {
    <div class="flex flex-col items-center justify-center h-64">
      <p>{{ 'pages.admin.userGroup.tabs.invitations.selectRole' | translate }}</p>
      <p>{{ 'pages.admin.userGroup.tabs.invitations.campaignUserDescription' | translate }}</p>
    </div>
  }
</div>
